import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LoadingContext } from '../../contexts';
import DefaultSection, {HorizontalRule} from '../../components/default_section/default_section';
import DefaultInput, {HalfWrapper} from '../../components/default_input/default_input';
import WarningMessage from '../../components/warning_message/warning_message';
import './staff_data.scss';

class StaffData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleKeyDown(event) {
    if(event.keyCode === 13 && this.props.enableSave && !this.props.isLoading) {
      this.props.onSave();
    }
  }

  isHighlighted(propertyName) {
    return this.props.highlights.includes(propertyName);
  }

  render() {
    return (
      <DefaultSection
        className="staff-data"
        title="Dados do colaborador"
      >

        {this.props.isEdit &&
          <>
          
            <div className="staff-data__actions-container">

              <button
                className="default-section__default-link-button"
                onClick={() => this.props.onCopyPasswordDefinitionLink()}
                disabled={this.props.isLoading}
              >

                  <i className="fas fa-link default-section__default-link-button__icon"></i> {this.props.passwordRecoveryLinkCopied ? 'Link copiado' : 'Copiar link para redefinir senha'}

              </button>

            </div>

            <HorizontalRule />

          </>
        }

        <div className="staff-data__warning-container">

          <WarningMessage
            message={this.props.warningMessage}
            onClose={this.props.onCloseWarning}
            visible={this.props.showWarningMessage}
          />

        </div>

        <form className="staff-data__input-container">

          <DefaultInput
            name="is_active"
            isHighlighted={this.isHighlighted("is_active")}
            label="Ativo:"
            type="toggle"
            isHorizontal={true}
            activeText="Sim"
            inactiveText="Não"
            handleInputChange={this.props.handleInputChange}
            value={this.props.user.is_active}
            horizontalAlign="right"
            disabled={this.props.isLoading}
          />

          <HalfWrapper>

            <DefaultInput
              name="name"
              isHighlighted={this.isHighlighted("name")}
              label="Nome"
              type="text"
              placeholder="Nome do colaborador"
              maxLength="128"
              handleInputChange={this.props.handleInputChange}
              value={this.props.user.name}
              autoComplete="off"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

            <DefaultInput
              name="email"
              isHighlighted={this.isHighlighted("email")}
              label="E-mail"
              type="email"
              placeholder="E-mail do colaborador"
              maxLength="128"
              handleInputChange={this.props.handleInputChange}
              value={this.props.user.email}
              autoComplete="off"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

          </HalfWrapper>

          <HalfWrapper>

            <DefaultInput
              name="password"
              isHighlighted={this.isHighlighted("password")}
              label="Senha"
              labelMessage="(Opcional)"
              type="password"
              placeholder="Senha de acesso do colaborador"
              maxLength="32"
              handleInputChange={this.props.handleInputChange}
              value={this.props.user.password}
              autoComplete="new-password"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

            <DefaultInput
              name="password_confirmation"
              isHighlighted={this.isHighlighted("password_confirmation")}
              label="Confirmação de senha"
              type="password"
              placeholder="Confirmação de senha"
              maxLength="32"
              handleInputChange={this.props.handleInputChange}
              value={this.props.user.password_confirmation}
              autoComplete="new-password"
              onKeyDown={(event) => this.handleKeyDown(event)}
              disabled={this.props.isLoading}
            />

          </HalfWrapper>

        </form>

        <HorizontalRule />

        <div className="staff-data__buttons-container">

          <button
            className="staff-data__save-button"
            disabled={!this.props.enableSave || this.props.isLoading}
            onClick={this.props.onSave}
          >

            Salvar

          </button>

          <Link
            className="staff-data__cancel-button"
            to={this.props.onCancelPath}
            disabled={this.props.isLoading}
          >

            Cancelar

          </Link>

        </div>

      </DefaultSection>
    );
  }
};

const WrappedStaffData = props => {
  const {isLoading} = useContext(LoadingContext);

  return (
    <StaffData
      isLoading={isLoading}
      {...props}
    />
  );
};

export {WrappedStaffData as StaffData};
